import * as actionTypes from 'domains/campaigns/state/actionTypes';

export const editPublish = () => ({
    type: actionTypes.CONDITIONAL_SPLIT_EDIT_PUBLISH,
});
